import React from "react";
import { Container, Row, Card, CardBody, Table } from "reactstrap";
import "react-slide-out/lib/index.css";
import * as env from "../../../../env";
import { columnHeader } from "./config";
import Pagination from "../../../../shared/components/pagination/Pagination";
import MoreActions from "./MoreActions";
import Slider from "react-slide-out";
import FormComponent from "./form";
import client from "../../../../shared/api-client";
import Modal from "../../../../shared/modal";

class PackagesListing extends React.Component {
  state = {
    title: "Products",
    addTitle: "Add Product",
    editTitle: "Edit Product",
    isOpen: false,
    results: [],
    filteredResults: [],
    columnHeader: columnHeader,
    filters: [],
    filterValues: {
      type: [],
      concurrent_connection: [],
      locations: [],
    },
    startIndex: 0,
    endIndex: env.RECORDS_PER_PAGE,
    editable: [],
    save: {
      type: "Premium",
      proxies: {},
    },
    locations: [],
    subnets: [],
    show: false,
  };

  getResults() {
    this.setState({ loading: true });

    client(`packages.php`).then(
      (response) => {
        response.packages.map((packageObj) => {
          packageObj.location_names = [];
          return packageObj;
        });
        this.setResults(response.packages);
        this.setState({ loading: false });
      },
      (error) => {
        console.error(error);
      }
    );
  }

  setResults = (results) => {
    this.setState({
      isOpen: false,
      results: results,
      filteredResults: results,
    });

    let filterValues = this.state.filterValues;

    results.map((result) => {
      this.state.columnHeader.map((header) => {
        if (header.type === "list") {
          switch (header.key) {
            default:
              if (!filterValues[header.key].includes(result[header.key])) {
                filterValues[header.key].push(result[header.key]);
              }
          }
        }

        return header;
      });

      return result;
    });
  };

  componentDidMount() {
    this.getResults();
    this.getSubnets();
  }

  getSubnets = () => {
    client(`subnets.php`).then(
      (subnets) => {
        this.setState({ subnets: subnets });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  formChangeHandler = (event) => {
    let filters = this.state.filters;
    let filter = { name: event.target.name, value: event.target.value };

    var foundIndex = filters.findIndex((x) => x.name === filter.name);

    if (foundIndex >= 0) {
      filters[foundIndex] = filter;
    } else {
      filters.push(filter);
    }

    this.setState({ filters });
    this.filterResults();
  };

  filterResults = () => {
    let filteredResults = this.state.results;

    this.state.filters.forEach((element, index) => {
      if (element.value.trim() !== "") {
        switch (element.name) {
          case "id":
          case "subnets":
          case "locations":
          case "valid":
          case "cost":
          case "number":
            filteredResults = filteredResults.filter((o) =>
              Object.keys(o).some((k) =>
                String(o[element.name])
                  .toLowerCase()
                  .includes(element.value)
              )
            );
            break;
          case "type":
          default:
            filteredResults = filteredResults.filter((o) =>
              Object.keys(o).some((k) =>
                o[element.name]
                  .toLowerCase()
                  .includes(element.value.toLowerCase())
              )
            );
        }
      }
    });

    this.setState({ filteredResults });
  };

  printFilters = () => {
    return (
      <tr>
        {this.state.columnHeader.map((data) =>
          data.filter ? (
            <th key={data.key}> {this.printFilterInput(data)}</th>
          ) : (
            <th></th>
          )
        )}
        <th></th>
      </tr>
    );
  };

  printFilterInput = (input) => {
    return (
      <input
        name={input.key}
        type="text"
        onChange={this.formChangeHandler}
      ></input>
    );
  };

  printOptions = (key) => {
    return (
      <React.Fragment>
        {this.state.filterValues[key].map((value) => (
          <option value={value}>{value}</option>
        ))}
      </React.Fragment>
    );
  };

  submit = () => {
    let method = "PUT";

    if (this.state.save.id !== undefined) {
      method = "POST";
    }

    let packageObj = this.state.save;

    delete packageObj.subnets;
    delete packageObj.subnet_suggestions;
    delete packageObj.noOfProxies;

    client(`packages.php`, {
      method: method,
      body: packageObj,
    }).then(
      (response) => {
        this.getResults();
        this.setState({ loading: false });
        //this.setState({show: true, success: response._user_message});
      },
      (error) => {
        this.setState({ show: true, errors: error._user_message });
      }
    );
  };

  delete = (data) => {
    alert("Delete #" + data.id);
    console.log("products delete", data);
  };

  printRecords = () => {
    let items = this.state.filteredResults.slice(
      this.state.startIndex,
      this.state.endIndex + 1
    );

    return (
      <React.Fragment>
        {items.map((data) => (
          <tr key={data.id}>
            {this.state.columnHeader.map((column, index) => (
              <td key={index}>
                {column.key === "proxies"
                  ? data[column.key].map((proxie) => (
                      <span className="w3-badge">
                        {proxie.location} {proxie.subnet}
                      </span>
                    ))
                  : data[column.key]}
              </td>
            ))}
            <td>
              <MoreActions
                onEditClicked={(data) => {
                  this.setState({ isOpen: true, editable: data });
                }}
                onDeleteClicked={(data) => {
                  this.delete(data);
                }}
                item={data}
              />
            </td>
          </tr>
        ))}
      </React.Fragment>
    );
  };

  usersListingUrl = (product) => {
    return `/proxy/products/users/${product.id}`;
  };

  pagination = () => {
    return this.state.filteredResults.length > env.RECORDS_PER_PAGE ? (
      <div className="audit-trail-footer">
        <Pagination
          items={this.state.filteredResults}
          onChangePage={(pagination) => this.setState(pagination)}
          pageSize={env.RECORDS_PER_PAGE}
        />
      </div>
    ) : (
      ""
    );
  };

  toggleAddNew = () => {
    this.setState({ isOpen: true, editable: [], save: [] });
  };

  printActions = () => {
    return (
      <React.Fragment>
        <button
          type="button"
          onClick={() => this.toggleAddNew()}
          className="btn btn-sm btn-primary"
        >
          {this.state.addTitle}
        </button>
      </React.Fragment>
    );
  };

  render() {
    return (
      <Container>
        <Row className="user-section">
          <Card className="table-section form">
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">{this.state.title}</h5>
                <div className="toolbar-buttons">{this.printActions()}</div>
              </div>
              <Table
                responsive
                hover
                className="table--head-accent table--bordered"
              >
                <thead>
                  <tr>
                    {this.state.columnHeader.map((data) => (
                      <th key={data.key}>{data.name}</th>
                    ))}
                    <th></th>
                  </tr>
                  {this.printFilters()}
                </thead>
                <tbody>{this.printRecords()}</tbody>
              </Table>
              {this.pagination()}
            </CardBody>
          </Card>
        </Row>
        <Slider
          isOpen={this.state.isOpen}
          footer={
            <div className="button-container">
              <button
                className="square btn btn-primary btn-sm"
                onClick={this.submit}
                type="button"
              >
                Submit
              </button>
              <button
                type="button"
                className="square btn btn-danger btn-sm"
                onClick={() => this.setState({ isOpen: false })}
              >
                Cancel
              </button>
            </div>
          }
          onOutsideClick={() => this.setState({ isOpen: false })}
        >
          <FormComponent
            title={
              this.state.editable.id !== undefined
                ? this.state.editTitle
                : this.state.addTitle
            }
            toggleAddNewUser={this.toggleAddNew}
            handleForm={(formValues) => this.setState({ save: formValues })}
            edit={{ ...this.state.editable }}
            subnets={this.state.subnets}
            proxies={this.state.save.proxies}
            showError={(errors) =>
              this.setState({ show: true, errors: errors })
            }
          />
        </Slider>
        <Modal
          onClose={() => this.setState({ show: false })}
          show={this.state.show}
          errors={this.state.errors}
          success={this.state.success}
        ></Modal>
      </Container>
    );
  }
}

export default PackagesListing;
